











































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import MisSolicitudesExportDialog from './exportDialog.vue';
import {
  ConfigCategorias,
  fetchCategorias,
  ConfigEmpresas,
  fetchEmpresas,
  ConfigEstados,
  fetchEstados,
  fetchMS,
} from '@/pantallas/SucursalVirtual/NuevaSolicitud/fetchConfigInicial';

import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';

@Component({
  components: {
    MisSolicitudesExportDialog,
  },
})
export default class MisSolicitudesFilters extends Vue {
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  estados: ConfigEstados[] = [];
  categorias: ConfigCategorias[] = [];
  advancedFilters: boolean = false;
  showDialog: boolean = false;
  menu: boolean = false;
  menu2: boolean = false;
  @Prop() categoriaUsuario: string;
  @Prop() empresas: ConfigEmpresas[];

  filterField: any = {
    IdCliente: null,
    IdRazo: null,
    IdCategoria: '',
    fechadesde: '',
    fechahasta: '',
    LstCuentas: '',
    filtroTexto: '',
    OrderBy: 'caso.CreatedOn',
    Orden: 'DESC',
  };

  constructor() {
    super();
    this.getCategorias();
    //this.getEmpresas();
    this.getEstados();
    if (this.categoriaUsuario == 'Externo') {
      this.filterField.IdCliente = JSON.parse(
        window.localStorage.user
      ).rutClienteDefecto || JSON.parse(window.localStorage.user).clienteDefecto;
    }
  }

  mounted() {
    //this.getCategoriaUsuario();
    //console.log(this.categoriaUsuario);
    if (this.categoriaUsuario == 'Externo') {
      this.filterField.IdCliente = JSON.parse(
        window.localStorage.user
      ).rutClienteDefecto || JSON.parse(window.localStorage.user).clienteDefecto;
    }
  }

  closeDialog(e: boolean) {
    this.showDialog = e;
  }

  async getCategorias() {
    this.categorias = (await this.cargarCategorias()) || [];
    this.categorias.forEach(function(v) {
      if (v.header != '') {
        delete v.nombre;
        delete v.id;
      } else {
        delete v.header;
      }
    });
  }
  cargarCategorias() {
    return fetchCategorias().catch(error => {
      if (error.message == 'Network Error') {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las categorias',
          { timeout: 3000 }
        );
      } else if (error.response.status != 404) {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las categoriasp',
          { timeout: 3000 }
        );
      }
    });
  }

  async getEstados() {
    const response: any = (await this.cargarEstados()) || [];
    this.estados = response.data.data;
  }
  cargarEstados() {
    return fetchEstados().catch(error => {
      if (error.message == 'Network Error') {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener los estados',
          { timeout: 3000 }
        );
      } else if (error.response.status != 404) {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener los estados',
          { timeout: 3000 }
        );
      }
    });
  }

  clearFilter() {
    this.advancedFilters = false;
    this.filterField = {
      IdCliente: null,
      IdRazo: null,
      IdCategoria: '',
      fechadesde: '',
      fechahasta: '',
      LstCuentas: this.empresas[0].idGrupoCuentas,
      filtroTexto: '',
      OrderBy: 'caso.CreatedOn',
      Orden: 'DESC',
    };
  }
}
